// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.heading-top[data-v-f9561c86] {\n  margin-bottom: 10px;\n}\n.heading-top__main[data-v-f9561c86] {\n  font-size: 32px;\n  font-weight: 400;\n  color: #E94861;\n}\n.heading-top__sub[data-v-f9561c86] {\n  font-size: 20px;\n  color: #CBCBCB;\n}\n", ""]);
// Exports
module.exports = exports;
